import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableGroup = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.17383 0.181951C8.69766 -0.0606505 9.30234 -0.0606505 9.82617 0.181951L17.5113 3.73308C17.8102 3.8702 18 4.16906 18 4.49956C18 4.83006 17.8102 5.12892 17.5113 5.26604L9.82617 8.81717C9.30234 9.05977 8.69766 9.05977 8.17383 8.81717L0.488672 5.26604C0.189844 5.1254 0 4.82655 0 4.49956C0 4.17258 0.189844 3.8702 0.488672 3.73308L8.17383 0.181951V0.181951ZM15.641 7.36859L17.5113 8.23352C17.8102 8.37064 18 8.6695 18 9C18 9.3305 17.8102 9.62936 17.5113 9.76648L9.82617 13.3176C9.30234 13.5602 8.69766 13.5602 8.17383 13.3176L0.488672 9.76648C0.189844 9.62584 0 9.32699 0 9C0 8.67302 0.189844 8.37064 0.488672 8.23352L2.35898 7.36859L7.70273 9.8368C8.10948 10.0244 8.55207 10.1216 9 10.1216C9.44793 10.1216 9.89052 10.0244 10.2973 9.8368L15.641 7.36859V7.36859ZM10.2973 14.3372L15.641 11.869L17.5113 12.734C17.8102 12.8711 18 13.1699 18 13.5004C18 13.8309 17.8102 14.1298 17.5113 14.2669L9.82617 17.818C9.30234 18.0607 8.69766 18.0607 8.17383 17.818L0.488672 14.2669C0.189844 14.1263 0 13.8274 0 13.5004C0 13.1735 0.189844 12.8711 0.488672 12.734L2.35898 11.869L7.70273 14.3372C8.10948 14.5249 8.55207 14.622 9 14.622C9.44793 14.622 9.89052 14.5249 10.2973 14.3372V14.3372Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgTableGroup);
export { ForwardRef as ReactComponent };
